

<template>
  <div style="height: 100vh; width: 100vw;">
    <l-map
      :key="mapKey"
      v-model="zoom"
      v-model:zoom="zoom"
      :center="center"
      @move="log('move')"
      :min-zoom="zoom"
      :max-zoom="zoom"
      :options="mapOptions"
      :leaflet-options="{preferCanvas: false}"
      ref="lmap"
      @update:map-object="mapObject = $event"
      @ready="onMapReady"
      
    >
    <!-- 
      :min-zoom="19.3"
      :max-zoom="19.3"
     -->

      <!-- leaflet map -->
      <l-tile-layer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      ></l-tile-layer>

      <!-- illustration map -->
      <l-image-overlay
        :url="svgIcon"
        :bounds="imageBounds"
        :interactive="true"
      ></l-image-overlay>

      <!-- points of interest -->
      <l-marker v-for="(point, index) in pointsOfInterest" :key="index" :lat-lng="point.latlng">
        <l-icon :icon-url="imagePath" :icon-size="[16, 16]" :icon-anchor="[8, 8]" />
      </l-marker>

      <!-- user person -->
      <l-marker class="user-marker" :lat-lng="userLocation" :z-index-offset="99999999999">
        <l-icon :icon-url="person" :icon-size="[64, 64]" :icon-anchor="[32, 64]" />
      </l-marker>

    </l-map>
    <div v-if="closestPointOfInterest !== null" class="poiButton">
      <button v-on:click="poiLink(closestPointOfInterest.name, closestPointOfInterest.link)">View {{ closestPointOfInterest.label }}</button>
    </div>
    <canvas id="confetti-canvas" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></canvas>

    

  </div>
  <NavBar></NavBar>

  <div>
    <InfoModal :is-open="isModalOpen" @close="closeModal"
           header="Explore Wellen Park"
           image-url="img/wellen-image.jpeg"
           paragraph="Discover the wonders of Wellen Park through our interactive map and scavenger hunt. Engage with each point of interest and see what it's like to live in this vibrant community."></InfoModal>
  </div>


  <FooterBadges v-if="!tooFar" :activeItems="activeImages" />
  <InvisibleButton />

  <div v-if="tooFar" id="too-far">
    <div>
      
      <h2 id="visitAgain">Come visit us again</h2>

      <ThumbnailLink
        v-for="(item, index) in thumbs"
        :key="index"
        :url="item.url"
        :image="item.image"
        :caption="item.caption"
      />

      <!-- <p style="width: 90%; margin: auto;">We'd love to come home with you, but this is an onsite experience.</p>
      <img class="mb-5 mt-5" src="/img/wellen-image.jpeg">
      <button class="backButton mt-3" v-on:click="backToWebsite">Back to Wellen Park</button> -->
    </div>
      
  </div>
</template>
<script>
import myImage from '@/assets/poi.png';
import person from '@/assets/person-icon.png';
import myMap from '@/assets/map-4096b.jpg';
import wellenLogo from '@/assets/wellen-logo.svg';
import wellenImage from '@/assets/wellen-image.jpeg';
import fishThumb from '@/assets/fish-thumbnail.jpg';
import tortoiseThumb from '@/assets/tortoise-thumbnail.jpg';
import lanternThumb from '@/assets/lantern-thumbnail.jpg';
import butterfliesThumb from '@/assets/butterflies-thumbnail.jpg';
// import L from 'leaflet';
import {
  LMap,
  LTileLayer,
  LMarker,
  LIcon,
  LImageOverlay,
} from "@vue-leaflet/vue-leaflet";
import "leaflet/dist/leaflet.css";
import NavBar from '@/components/NavbarComponent.vue';
import FooterBadges from '@/components/FooterBadges.vue';
import InvisibleButton from '@/components/InvisibleButton.vue';
import InfoModal from '@/components/InfoModal.vue';
import { pointsOfInterest } from './poi.js';
import confetti from 'canvas-confetti';
import ThumbnailLink from './components/ThumbnailLink.vue';
var KalmanFilter = require('kalmanjs');

// import { ref, onMounted } from "vue";


export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
    LImageOverlay,
    NavBar,
    FooterBadges,
    InvisibleButton,
    InfoModal,
    ThumbnailLink
},
  data() {
    return {
      // zoom: 8,
      zoom: 19.3,
      mapKey: 0,
      iconWidth: 25,
      iconHeight: 40,
      mapOptions: {
        dragging: false,
        zoomControl:false,
        attributionControl: false
      },
      centerTooFar: [27.046429339211905, -82.3278645251399],
      center: [27.046429339211905, -82.3278645251399],
      userLocation: [27.046429339211905, -82.3278645251399],
      imagePath: myImage,
      person: person,
      pointsOfInterest,
      activeImages: [],
      closestPointOfInterest: null,
      mapObject: null,
      svgIcon: myMap,
      loadingSVGIcon: true,
      imageBounds: this.calculateBounds([27.04816, -82.3302], 0.0034, 0.0046),
      tooFar: false,
      wellenLogo: wellenLogo,
      wellenImage: wellenImage,
      fishThumb: fishThumb,
      butterfliesThumb: butterfliesThumb,
      tortoiseThumb: tortoiseThumb,
      lanternThumb: lanternThumb,
      isModalOpen: false,
      thumbs:[
        {url:"/threejs/lantern.html", image:"/img/lantern-thumbnail.jpg", caption:"Light up the night"},
        {url:"/threejs/fish.html", image:"/img/fish-thumbnail.jpg", caption:"Plenty of fish in the sea"},
        {url:"https://webxr.run/r339Ee7LQ49QX", image:"/img/tortoise-thumbnail.jpg", caption:"Wildlife"},
        {url:"https://webxr.run/E2g8xz0l6LZWG", image:"/img/butterflies-thumbnail.jpg", caption:"Butterflies"}
      ],
      kalmanFilterLat: new KalmanFilter({R: 0.005, Q: 3}),
      kalmanFilterLng: new KalmanFilter({R: 0.005, Q: 3})
    };
  },
  methods: {
    log(a) {
        console.log(a);
    },
    onMapReady() {
      this.$nextTick(() => {
        this.rotateMap();
      });
    },
    calculateBounds(topLeft, heightDegrees, widthDegrees) {
      // topLeft: [latitude, longitude] of the top left corner
      // heightDegrees: height in latitude degrees
      // widthDegrees: width in longitude degrees
      return [
          topLeft, // top left corner
          [topLeft[0] - heightDegrees, topLeft[1] + widthDegrees] // bottom right corner
      ];
    },
    rotateMap() {
      if (this.mapObject) {
        const mapContainer = this.mapObject.getContainer();
        mapContainer.style.transform = "rotate(180deg)";
      }
    },
    backToWebsite(){
      location.href = "https://wellenpark.com/";
    },
    setCurrentLocation() {
    const options = {
        enableHighAccuracy: true,
        timeout: 1000,
        maximumAge: 0
    };

    navigator.geolocation.getCurrentPosition(
        position => {
            let lat = this.kalmanFilterLat.filter(position.coords.latitude);
            let lng = this.kalmanFilterLng.filter(position.coords.longitude);
            const userLatLng = [lat, lng];
            this.center = userLatLng;
            this.userLocation = userLatLng;
        },
        error => {
            console.error(error);
        },
        options
    );

    const closestPOI = this.findClosestPointOfInterest(this.userLocation);
    if (closestPOI !== null) {
        this.closestPointOfInterest = closestPOI;
    } else {
        this.closestPointOfInterest = null;
    }
},
    getMarkerLatLngFromURL() {
        const urlParams = new URLSearchParams(window.location.search);
        let location = urlParams.get('l');

        if (location == "bike") {
          location = "wildlife";
        }
        if (location == "solis") {
          location = "lantern";
        }

        const pointOfInterest = this.findObjectByName(location, pointsOfInterest);
        this.mapKey += 1;
        console.log("ran");
        if (pointOfInterest != null) {
            console.log("update center");
            console.log(pointOfInterest.latlng);
            this.userLocation = pointOfInterest.latlng;
            this.center = pointOfInterest.latlng;
            const closestPOI = this.findClosestPointOfInterest(pointOfInterest.latlng);
            if (closestPOI !== null) {
                this.closestPointOfInterest = closestPOI;
            } else {
                this.closestPointOfInterest = null;
            }
        }
    },
    findClosestPointOfInterest(userLatLng) {
    let closestDistance = null;
    let closestPOI = null;
    for (let i = 0; i < pointsOfInterest.length; i++) {
        const distance = this.getDistance(userLatLng, pointsOfInterest[i].latlng);
        if (closestDistance === null || distance < closestDistance) {
            closestDistance = distance;
            closestPOI = pointsOfInterest[i];
        }
    }

    const distanceTooFar = this.getDistance(userLatLng, this.centerTooFar);
    this.tooFar = distanceTooFar > 160;

    // Check for 'testing=1' in URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const testing = urlParams.get('testing');
    if (testing === '1') {
        this.tooFar = false;
        this.zoom = 18;
    }

    if (closestDistance !== null && closestDistance < 20) {
        return closestPOI;
    } else {
        return null;
    }
},

    congrats(){
      confetti.create(document.getElementById('confetti-canvas'), {
        resize: true,
        // useWorker: true,
      })({ 
        // particleCount: 200, spread: 200 
        particleCount: 100,
        spread: 70,
        origin: { y: 1.0 }
      });
    },
    getDistance(latlng1, latlng2) {
        const lat1 = latlng1[0];
        const lon1 = latlng1[1];
        const lat2 = latlng2[0];
        const lon2 = latlng2[1];
        const R = 6371e3;
        const φ1 = lat1 * Math.PI / 180;
        const φ2 = lat2 * Math.PI / 180;
        const Δφ = (lat2 - lat1) * Math.PI / 180;
        const Δλ = (lon2 - lon1) * Math.PI / 180;
        const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
            Math.cos(φ1) * Math.cos(φ2) *
            Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;
        return d;
    },
    findObjectByName(name, objects) {
        for (let i = 0; i < objects.length; i++) {
            if (objects[i].name === name) {
                return objects[i];
            }
        }
        return null;
    },
    loadFromLocalStorage(name) {
    const data = localStorage.getItem(name);
    console.log(data);
    if (data !== null) {
      this.activeImages = JSON.parse(data);
      if(this.activeImages.length > 3){
        this.congrats();
      }
    }
   
  },
  saveToLocalStorage(name) {
    const data = JSON.stringify(this.activeImages);
    localStorage.setItem(name, data);
  },
    poiLink(name, url){
      console.log(name);
      console.log(!this.activeImages.includes(name));
      if(!this.activeImages.includes(name)){
        console.log("saving");
        this.activeImages.push(name);
      }
      this.$nextTick(() => {
        this.saveToLocalStorage("activeImages");
      });
      setTimeout(() => {
        location.href = url;
      }, 100);
    },
    openModal() {
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
    },
    resetModal() {
      localStorage.removeItem('isModalOpened');
    }
  },
  mounted() {
    this.loadFromLocalStorage("activeImages");
    this.setCurrentLocation();
    setInterval(() => {
      this.setCurrentLocation();
    }, 1500);
    setTimeout(() => {
      this.getMarkerLatLngFromURL();
    }, 1000);
    // this.congrats();
  },
  created() {
    const isModalOpened = localStorage.getItem('isModalOpened');
    if (!isModalOpened) {
      this.openModal();
      localStorage.setItem('isModalOpened', 'true');
    }
  },
}
  
</script>

<style scoped>
.poiButton{
  position: absolute; 
  top: 75%; 
  left: 50%; 
  transform: translate(-50%, -50%);
  /* z-index: 600; */
}
.poiButton button{
  background: linear-gradient(-90deg, rgba(241,201,119,1) 0%, rgba(249,230,175,1) 100%);
  color: rgba(26,46,87,1);
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 3.2px;
  line-height: 1.250em;
  padding: 2.5rem 5.1rem;
  display: inline-block;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  z-index: 1;
  border: none;
  padding: 1.5rem 2.5rem;
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
}

.backButton{
  background: linear-gradient(-90deg, rgba(241,201,119,1) 0%, rgba(249,230,175,1) 100%);
  color: rgba(26,46,87,1);
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 3.2px;
  line-height: 1.250em;
  padding: 2.5rem 5.1rem;
  display: inline-block;
  text-transform: uppercase;
  position: relative;
  overflow: hidden;
  z-index: 1;
  border: none;
  padding: 1.5rem 2.5rem;
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
}

.leaflet-container{
  transform: rotate(180deg);
}

#confetti-canvas{
  pointer-events:none; 
}

#too-far{
  background-color: #fff;
  color: rgba(0,100,163,1);
  z-index: 600;
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  /* height: 100%; */

  text-align: center;
  font-family: Arial, Helvetica, sans-serif;

  display: flex;
  justify-content: center; /* horizontally center */
  align-items: center; /* vertically center */
}

#too-far h2{
  color: rgba(0,100,163,1);
}

#too-far img{
  /* width: 50%; */
}

.mt-3{
  margin-top: 3rem;
}

.mb-3{
  margin-bottom: 3rem;
}

#visitAgain{
  margin-top: 110px;
}

</style>